import React, { useState } from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { definitions } from './utils';
import PropTypes from 'prop-types';
import { BOGLE_REGULAR } from '../../constants/constant';

const TextWithDefinition = (props) => {
	const { text, styles, hasDefinition, definitionId, classStyle } = props;
	const [anchorEl, setAnchorEl] = useState(null);

	const handlePopoverOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	return (
		<>
			<Typography
				sx={{
					...styles,
					textDecoration: hasDefinition ? '#909196 2px underline dotted' : null,
					cursor: hasDefinition ? 'pointer' : 'text',
					textAlign: 'right',
					width: 'fit-content',
					fontFamily: `${BOGLE_REGULAR} !important`,
				}}
				className={classStyle}
				aria-owns={open ? 'mouse-over-popover' : undefined}
				aria-haspopup={hasDefinition ? 'true' : 'false'}
				onMouseEnter={handlePopoverOpen}
				onMouseLeave={handlePopoverClose}>
				{text}
			</Typography>
			{hasDefinition && (
				<Popover
					id="mouse-over-popover"
					sx={{
						pointerEvents: 'none',

						'& .MuiPopover-paper': {
							width: '280px',
							padding: '16px',
							fontFamily: `${BOGLE_REGULAR} !important`,
							boxShadow:
								'0px -1px 4px 0px rgba(0, 0, 0, 0.10), 0px 5px 10px 3px rgba(0, 0, 0, 0.15)',
						},
					}}
					open={open}
					anchorEl={anchorEl}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: -4,
						horizontal: 'left',
					}}
					onClose={handlePopoverClose}
					disableRestoreFocus>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							gap: '16px',
						}}>
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'column',
								gap: '8px',
							}}>
							<Box>
								<Typography
									sx={{
										fontSize: '14px',
										lineHeight: '20px',
										fontWeight: 700,
									}}>
									{text}
								</Typography>
							</Box>
							<Box>
								<Typography
									sx={{
										fontSize: '14px',
										lineHeight: '20px',
										fontWeight: 400,
									}}>
									{definitions[definitionId]?.definition}
								</Typography>
							</Box>
						</Box>
					</Box>
				</Popover>
			)}
		</>
	);
};

TextWithDefinition.defaultProps = {
	text: '',
	styles: {},
	hasDefinition: false,
	definitionId: '',
};

TextWithDefinition.propTypes = {
	text: PropTypes.string,
	styles: PropTypes.object,
	hasDefinition: PropTypes.bool,
	definitionId: PropTypes.string,
	classStyle: PropTypes.object,
};

export default TextWithDefinition;
